import Heading from 'components/Heading'
import Modal from 'components/Modal'
import React, { PropTypes, Component } from 'react'
import Table from 'components/Table'
import Card from 'components/Card'
import DocumentAwaitingPlan from '../../../icons/svg/DocumentAwaitingPlan.svg'
import { IconEPICDocument, IconDocumentDone } from '../../../icons'
import { DocumentCard } from './components'
import Loading from 'components/Loading'
import constants from 'constants'
// import moment from 'moment'
import { format, parse } from 'date-fns'

const styles = Object.assign(
  {},
  require('./PartnerPlanDocumentDisplayForm.scss'),
  { columns: require('./columns.scss') },
  { table: require('components/Table/Table.scss') },
)

class PartnerPlanDocumentDisplayForm extends Component {
    static propTypes = {
      hide: PropTypes.func.isRequired,
      id: PropTypes.string,
      modals: PropTypes.object.isRequired,
      partnerPlan: PropTypes.obj,
    }

    static defaultProps = {
      id: 'partnerPlanStatusForm',
      partnerPlan: null,
    }

    _hide = () => {
      this.props.hide(this.props.id)
    }

    render() {
      const {
        title,
        modals,
        description,
        partnerPlan,
      } = this.props    
      return (
        <Modal
          className={styles.bg}
          disable={false}
          forceClose={false}
          id="partnerPlanDocumentForm"
          modals={modals}
          onClose={this._hide}
        >          
          <div className={styles.base}>
            <Heading className={styles.title} size="large">
              {title}
            </Heading>
            <p className={styles.content}>{description}</p>
            {partnerPlan.isFetching && <Loading pageLoading />} 
            {!partnerPlan.isFetching && partnerPlan.partnerPlanDocuments && partnerPlan.partnerPlanDocuments.length > 0 &&
            <section className={styles.plandocuments}>
              <Heading noTopPadding>My plan</Heading>
              <Card noPadding>
                <Table>
                  { partnerPlan.partnerPlanDocuments.filter(pp => pp.documentType === constants.PARTNERPLAN.DOCUMENTTYPE.PLAN).map((doc, i) => (
                   (i === 0 && <tr className={styles.base} key={doc.itemId}>
                     <td className={styles.columns.docIcon}>{
                       (doc.planStatus === constants.PARTNERPLAN.STATUS.DRAFT
                       || doc.planStatus === constants.PARTNERPLAN.STATUS.UPLOADED
                       || doc.planStatus === constants.PARTNERPLAN.STATUS.SUBMITTED)
                       ? <IconEPICDocument height="18" width="18" />
                       : <IconDocumentDone height="18" width="18" />}
                     </td>
                     <td className={styles.columns.docLink}>
                       <div><a href={doc.path} rel="noopener noreferrer" target="_blank" title={doc.documentName}>{doc.name}</a></div>
                       <div className={styles.columns.docDate}>Uploaded: {(doc.modifiedDate ? format(parse(doc.modifiedDate, constants.DATE_FORMAT.SPO_FORMAT, new Date()), constants.DATE_FORMAT.PARTNER_PLAN_DOCLIST) : '')}</div>
                     </td>
                   </tr>)
                 )) }
                </Table>
              </Card>
              <DocumentCard
                documentTitle={constants.PARTNERPLAN.STEPS.INTERIM_ASSESSMENT}
                partnerPlanDocuments={partnerPlan.partnerPlanDocuments.filter(pp => pp.documentType === constants.PARTNERPLAN.DOCUMENTTYPE.INTERIM)}
              />
              <DocumentCard
                documentTitle={constants.PARTNERPLAN.STEPS.FINAL_ASSESSMENT}
                partnerPlanDocuments={partnerPlan.partnerPlanDocuments.filter(pp => pp.documentType === constants.PARTNERPLAN.DOCUMENTTYPE.FINAL)}
              />
            </section>}
            {!partnerPlan.isFetching && partnerPlan.partnerPlanDocuments.length <= 0 &&
            <section className={styles.plandocuments}>
              <Heading noTopPadding>My plan</Heading>
              <Card cardMyPlan>
                <img alt="Document Awaiting Plan" src={DocumentAwaitingPlan} />
              </Card>
            </section>}
          </div>
        </Modal>
      )
    }
}

export default PartnerPlanDocumentDisplayForm



// WEBPACK FOOTER //
// ./src/views/PartnerReports/PartnerPlan/PartnerPlanDocumentDisplayForm.js